import FormFather from "@/Components/Form/FormFather";
import FormInputEmail from "@/Components/Form/FormInputs/FormInputEmail";
import FormInputsNumeric from "@/Components/Form/FormInputs/FormInputsNumeric";
import FormInputsText from "@/Components/Form/FormInputs/FormInputsText";
import { useContextTicketProvider } from "@/Context/Ticket/ContextTicketCartProvider";
import { useTicketCart } from "@/Hooks/TicketCart/useTicketCart";
import type { MBuyCarCheckout } from "@/Models/MBuyCarCheckout/MBuyCarCheckout";
import React, { useState } from "react";

type Props = {
  createParchaseOrder: (formDatas: MBuyCarCheckout) => void;
  isLoading: boolean;
};

const FormStore = ({ createParchaseOrder, isLoading }: Props) => {
  //const [isLoading, setIsLoading] = useState<boolean>(false);
  const { ResponseBasket } = useContextTicketProvider();
  const { addTicketProduct } = useTicketCart();
  const TotalSalesPrice = addTicketProduct.reduce((acc, item) => {
    return acc + (item.price ?? 0) * (item.quantity ?? 0);
  }, 0);

  let Quantity = Number(
    addTicketProduct.reduce((acc, item) => acc + (item.quantity ?? 0), 0)
  );

  //guardar los datos del usuario
  const [formDataTicket, setFormDataTicket] = useState<MBuyCarCheckout>({
    postalCode: "", //number
    cColonia: "",
    address1: "",
    cStreetNumber: "", //number
    interNumber: "",
    reference: "",
    city: "",
    stateCode: "",
    firstName: "Ariel",
    phone: "8711435934", //number
    countryCode: "MX", //mx mexico
    companyName: "",
    fullName: "",
    lastName: "Mata",
    //Importantes
    id: ResponseBasket?.basketId.toString() ?? "", //basketId
    //Importantes
    ipAddress: addTicketProduct[0]?.ipAddress ?? "",
    priceSale: TotalSalesPrice ?? 0,
    Quantity: Quantity ?? 0,
    email: "ariel@develop.mx",
  });

  const checkEmptyOrFalseFields = () => {
    // Crear un array para guardar los campos vacíos o en false
    const emptyOrFalseFields = (
      Object.keys(formDataTicket) as (keyof MBuyCarCheckout)[]
    ).filter((key) => {
      const values = formDataTicket[key];
      return values === "";
    });

    return emptyOrFalseFields;
  };

  const headleOnChangue = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = event.target;

    setFormDataTicket({
      ...formDataTicket,
      [name]: value,
    });
    //const invalidFields = checkEmptyOrFalseFields();
    //const ActivoButton = invalidFields.length > 0 ? false : true;
    //setAvility(ActivoButton);
  };

  const handleSubmit = () => {
    createParchaseOrder(formDataTicket);
    //const invalidFields = checkEmptyOrFalseFields();
    //if (invalidFields.length === 0) {
    //headleOnClickFrom(formDataTicket);
    //}
  };

  return (
    <FormFather isLoading={isLoading} HanddleOnSubmit={handleSubmit}>
      <div className="row">
        <div className="col-xl-12 col-md-12">
          <FormInputsText
            TitleLabel={"* Nombre(s)"}
            Name={"firstName"}
            Placeholder={"Ingrese su Nombre Ej: Lucas"}
            Value={formDataTicket.firstName}
            OnChange={headleOnChangue}
          />
        </div>
        <div className="col-xl-12 col-md-12">
          <FormInputsText
            TitleLabel={"* Apellido(s)"}
            Name={"lastName"}
            Placeholder={"Ingrese su Apellido Ej: Paz"}
            Value={formDataTicket.lastName}
            OnChange={headleOnChangue}
          />
        </div>
        <div className="col-xl-12 col-md-12">
          <FormInputsNumeric
            TitleLabel={"* Teléfono"}
            Name={"phone"}
            Placeholder={"Ingrese su Télegono Ej: 048711435934"}
            Value={formDataTicket.phone}
            OnChange={headleOnChangue}
          />
        </div>
        <div className="col-xl-12 col-md-12">
          <FormInputEmail
            TitleLabel={"* Correo electronico"}
            Name={"email"}
            Placeholder={"Ingrese su correo electronico Ej: Lucas@ejmplo.com"}
            Value={formDataTicket.email}
            OnChange={headleOnChangue}
          />
        </div>
      </div>
    </FormFather>
  );
};

export default FormStore;
